module.exports = __webpack_public_path__ + "media/images/iconPlus__accent-9eaf886155822a88e5f7d2c5fcbce9bc.png";